import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { LoginComponent } from './login/login.component';
import { NbAuthComponent } from '@nebular/auth';
import { MfaComponent } from './mfa/mfa.component';
import { MfaSuccessComponent } from './mfa_success/mfa_success.component';
import { MfaExpiredComponent } from './mfa_expired/mfa_expired.component';
import { MfaRejectedComponent } from './mfa_rejected/mfa_rejected.component';
import { MfaDoesNotExistComponent } from './mfa_does_not_exist/mfa_does_not_exist.component';

const routes: Routes = [{
  path: '',
  component: NbAuthComponent,
  children: [
    {
      path: '',
      component: LoginComponent,
    },
    {
      path: 'login',
      component: LoginComponent,
    },
    {
      path: 'mfa',
      component: MfaComponent,
    },
    {
      path: 'mfa_success',
      component: MfaSuccessComponent,
    },
    {
      path: 'mfa_expired',
      component: MfaExpiredComponent,
    },
    {
      path: 'mfa_rejected',
      component: MfaRejectedComponent,
    },
    {
      path: 'mfa_does_not_exist',
      component: MfaDoesNotExistComponent,
    },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthenticationRoutingModule {
}
